import axios from 'axios';
import authHeader from "@/service/auth-header";

class StockService {


    async getStocksForExchange(exchange, type) {
        console.log("[" + name + "][getStocks] exchange = ", exchange);
        return await axios.get(`/api/applications/si/stock/exchange/${exchange}/${type}`, {headers: authHeader()})
    }

    // async getStocks(exchange, type, page, size) {
    //     console.log("[" + name + "][getStocks] exchange = ", exchange);
    //     return await axios.get(`/api/applications/si/stock/exchange/${exchange}/${type}/${page}/${size}`, {headers: authHeader()})
    // }
    //
    // async getStocksWithoutPages(exchange, type) {
    //     console.log("[" + name + "][getStocksWithoutPages] exchange = ", exchange);
    //     return await axios.get(`/api/applications/si/stock/exchange/${exchange}/${type}`, {headers: authHeader()})
    // }
    //
    // async getStocksForType(type) {
    //     console.log("[" + name + "][getStocksForType] type = ", type);
    //     return await axios.get(`/api/applications/si/stock/type/${type}`, {headers: authHeader()})
    // }
    //
    // async searchStocksForExchangeByCode(exchange, code) {
    //     return await axios.get(`/api/applications/si/stock/search/code/${exchange}/${code}`, {headers: authHeader()})
    // }

    async searchStocksForExchangeByName(exchange, name) {
        return await axios.get(`/api/applications/si/stock/search/name/${exchange}/${name}`, {headers: authHeader()})
    }

    async searchStocksForCountryByName(country, name) {
        return await axios.get(`/api/applications/si/stock/search/country/name/${country}/${name}`, {headers: authHeader()})
    }

}

export default new StockService();
